import { render, staticRenderFns } from "./ContrastDetail.vue?vue&type=template&id=96530178&scoped=true"
import script from "./ContrastDetail.vue?vue&type=script&lang=js"
export * from "./ContrastDetail.vue?vue&type=script&lang=js"
import style0 from "./ContrastDetail.vue?vue&type=style&index=0&id=96530178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96530178",
  null
  
)

export default component.exports